<template>
  <div>
    <label class="col-form-label font-weight-bold"> {{ text }} </label>
    <div class="flex-row">
      <input
        :type="tipo"
        class="form-control p-3"
        :placeholder="placeholder"
        :disabled="disabled"
        :readonly="readonly"
      />
      <span class="input-group-text" id="addon-wrapping">{{ model_tipo }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: String,
    tipo: String,
    placeholder: "",
    readonly: String,
    disabled: String,
    model_tipo: String,
  },
};
</script>

<style scoped>
.input-group-text {
  display: flex;
  align-items: center;

  padding: 0.275rem 0.4rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  /* color: #212529; */
  text-align: center;
  white-space: nowrap;
  color: var(--white);
  background-color: var(--green);
  /* border: 1px solid #ced4da; */
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
  border-right: 1px solid var(--greyBtn);
  border-bottom: 1px solid var(--greyBtn);
  border-top: 1px solid var(--greyBtn);
  border-left: none;
}
.flex-row {
  display: flex;
}
.flex {
  flex-direction: column;
}

.col-form-label {
  padding-top: calc(0.375rem + 1px);
  padding-bottom: calc(0.375rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}
.form-control {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--inputColor);
  background-color: var(--white);
  background-clip: padding-box;
  border-left: 1px solid var(--greyBtn);
  border-bottom: 1px solid var(--greyBtn);
  border-top: 1px solid var(--greyBtn);
  border-right: none;

  /* border-radius: 0.35rem; */
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.flex-row:focus {
  color: var(--inputColor);
  background-color: var(--white);
  border-color: var(--borderInput);
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgb(9 243 107 / 25%);
}

.form-control:focus {
  animation: pulseGreenShadow 0.5s ease-in-out infinite alternate-reverse;
}

.flex-row:focus {
  color: var(--inputColor);
  background-color: var(--white);
  border-color: var(--borderInput);
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgb(9 243 107 / 25%);
}

.form-control:focus {
  animation: pulseGreenShadow 0.5s ease-in-out infinite alternate-reverse;
}
</style>
